import { Colors } from '@spotahome/ui-library';

export class Marker {
  constructor(
    map,
    {
      lat,
      lng,
      text,
      zIndex,
      className,
      markerIcon,
      isBooked,
      multiListingCount
    }
  ) {
    this.map = map;
    this.markerIcon = markerIcon;
    this.isBooked = isBooked;
    this.multiListingCount = multiListingCount;
    this.baseZIndex = zIndex;
    this.visible = true;
    this.listeners = [];

    // Create marker DOM element
    this.element = document.createElement('div');
    this.element.style.cursor = isBooked ? 'default' : 'pointer';
    this.element.style.whiteSpace = 'nowrap';
    this.element.style.width = 'max-content';

    // Create label element (price markers on search page)
    if (text) {
      this.labelEl = document.createElement('div');
      this.labelEl.className = className || '';
      this.labelEl.textContent = text;
      this.element.appendChild(this.labelEl);
    } else if (markerIcon) {
      // Icon-only marker (e.g. listing page big marker, POI marker)
      const iconEl = document.createElement('img');
      iconEl.src = markerIcon;
      iconEl.style.display = 'block';
      this.element.appendChild(iconEl);
    }

    // Create multi-listing count badge
    if (multiListingCount > 0) {
      this.bubbleEl = document.createElement('div');
      this.bubbleEl.textContent = `${multiListingCount}`;
      this.bubbleEl.style.position = 'absolute';
      this.bubbleEl.style.top = '-12px';
      this.bubbleEl.style.right = '-13px';
      this.bubbleEl.style.background = Colors['secondary-blue'];
      this.bubbleEl.style.color = 'black';
      this.bubbleEl.style.width = '26px';
      this.bubbleEl.style.height = '24px';
      this.bubbleEl.style.display = 'flex';
      this.bubbleEl.style.alignItems = 'center';
      this.bubbleEl.style.justifyContent = 'center';
      this.bubbleEl.style.borderRadius = '50%';
      this.bubbleEl.style.fontSize = '14px';
      this.bubbleEl.style.fontWeight = 'bold';
      this.bubbleEl.style.boxShadow = '0px 2px 5px rgba(0,0,0,0.3)';
      this.bubbleEl.style.userSelect = 'none';
      this.bubbleEl.style.zIndex = zIndex;
      this.element.appendChild(this.bubbleEl);
    }

    this.position = new window.mapboxgl.LngLat(parseFloat(lng), parseFloat(lat));

    this.mapboxMarker = new window.mapboxgl.Marker({
      element: this.element,
      anchor: 'center'
    })
      .setLngLat(this.position)
      .addTo(map);
  }

  addListener = (eventName, callback) => {
    // Remove existing listeners for this event
    this.listeners = this.listeners.filter(l => {
      if (l.eventName === eventName) {
        this.element.removeEventListener(l.domEvent, l.handler);
        return false;
      }
      return true;
    });

    // Map Google Maps event names to DOM events
    const domEventMap = {
      click: 'click',
      mouseover: 'mouseenter',
      mouseout: 'mouseleave'
    };
    const domEvent = domEventMap[eventName] || eventName;

    const handler = e => {
      const lngLat = this.mapboxMarker.getLngLat();
      callback({
        latLng: {
          lat: () => lngLat.lat,
          lng: () => lngLat.lng
        },
        domEvent: e
      });
    };

    this.element.addEventListener(domEvent, handler);
    this.listeners.push({ eventName, domEvent, handler });
  };

  isVisible = () => this.visible;

  remove = () => {
    this.listeners.forEach(({ domEvent, handler }) => {
      this.element.removeEventListener(domEvent, handler);
    });
    this.listeners = [];
    this.visible = false;
    this.mapboxMarker.remove();
  };

  display = () => {
    this.visible = true;
    this.mapboxMarker.addTo(this.map);
  };

  updateIcon = ({ className, zIndex = this.baseZIndex }) => {
    // Set zIndex on the Mapbox marker wrapper (the .mapboxgl-marker element)
    const wrapper = this.element.parentElement;
    if (wrapper) {
      wrapper.style.zIndex = zIndex;
    }

    if (this.labelEl) {
      this.labelEl.className = className || '';
    }
  };

  getBoundaries = () => {
    const lngLat = this.mapboxMarker.getLngLat();
    return { lat: lngLat.lat, lng: lngLat.lng };
  };
}

const createMarker = (map, opts) => new Marker(map, opts);
export default createMarker;
